@if (offer && content) {
  <div class="commodity-offer-price-tag">
    @if (
      showBudgetbillProposal && termijnbedragVariantA && !termijnbedragVariantB
    ) {
      <ng-container
        *ngTemplateOutlet="budgetBillProposalTemplate"
      ></ng-container>
    }
    <div
      class="commodity-offer-price-tag__title"
      [ngClass]="termijnbedragVariantA || termijnbedragVariantB ? 'lh-sm' : ''"
    >
      <span
        [ngClass]="
          termijnbedragVariantA || termijnbedragVariantB ? 'fw-bold' : ''
        "
      >
        @if (
          offer.incentiveId && (termijnbedragVariantA || termijnbedragVariantB)
        ) {
          {{ content.withDiscountAlternateLabel }}
        } @else {
          {{ content.monthlyCostsLabel }}
        }
      </span>
      @if (showMonthlyCostsLabelDiscountInfix()) {
        <span>&nbsp;{{ content.monthlyCostsLabelDiscountInfix }}</span>
      }
      <span class="d-block">
        {{ content.monthlyCostsLabelSuffix }}
      </span>
    </div>
    <div class="commodity-offer-price-tag__monthly-amount">
      <span class="h1 mb-0">
        {{ offer.expectedMonthlyAmount | roundedCurrency }}
      </span>
      <span class="lh-sm font-sm" [ngClass]="monthlyCostLabelStyling()">{{
        content.priceDurationLabel
      }}</span>
    </div>

    @if (showBudgetbillProposal && !termijnbedragVariantA) {
      <ng-container
        *ngTemplateOutlet="budgetBillProposalTemplate"
      ></ng-container>
    }
  </div>
}

<ng-template #budgetBillProposalTemplate>
  <wl-commodity-offer-budgetbill-proposal
    class="w-100"
    [offer]="offer"
    [content]="content"
    [termijnbedragVariantA]="termijnbedragVariantA"
    [termijnbedragVariantB]="termijnbedragVariantB"
    [ngClass]="termijnbedragVariantA || termijnbedragVariantB ? 'lh-sm' : ''"
  ></wl-commodity-offer-budgetbill-proposal>
</ng-template>
